import {BasePureComponent} from "../../../BaseComponent";
import * as React from "react";
import {CustomDropzone} from "../../Dropzone/CustomDropzone";
import {DropEvent} from 'react-dropzone';

interface IDocumentHeader {
    Label?: any;
    OnComponentChange: () => void;
    OnDrop: (acceptedFiles: File[], rejectedFiles: File[], event: DropEvent) => any;
    AcceptedFiles?: string;
    AddEnabled?: boolean
}

export class DocumentHeader extends BasePureComponent<IDocumentHeader> {
    render() {
        let Dropzone: any = null;
        if (this.props.AddEnabled != undefined && this.props.AddEnabled) {
            Dropzone = <CustomDropzone AcceptedFiles={this.props.AcceptedFiles}
                OnDrop={((acceptedFiles: File[], rejectedFiles: File[], event: DropEvent) => {
                    this.props.OnDrop(acceptedFiles, rejectedFiles, event);
                    if (acceptedFiles.length) {
                        this.props.OnComponentChange();
                    }
                })}>
                <a className="btn btn-sm btn-label-brand btn-bold">
                    <i className="flaticon-download-1" />
                </a>
            </CustomDropzone>;
        }
        return <>
            <div className="kt-portlet__head-label">
                {this.props.Label}
            </div>
            <div className="kt-portlet__head-toolbar">
                {Dropzone}
            </div>
        </>
    }
}


// WEBPACK FOOTER //
// ./src/components/custom/Document/DocumentBox/DocumentHeader.tsx